import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const quoteId = location.state?.quoteId;

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 max-w-lg w-full text-center">
        <div className="w-20 h-20 bg-[#2F5E96] rounded-full flex items-center justify-center mx-auto mb-6">
          <Check className="w-10 h-10 text-white" />
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-[#27292E] mb-4">
          Quote Submitted Successfully!
        </h1>
        
        <p className="text-lg text-gray-600 mb-2">
          Thank you for your quote request.
        </p>
        
        <p className="text-base text-gray-500 mb-8">
          Our team will review your requirements and get back to you shortly with a detailed quote.
        </p>
        
        {quoteId && (
          <div className="bg-[#E0E9EB] rounded-xl p-4 mb-8">
            <p className="text-sm text-gray-600 mb-1">Your Quote Reference:</p>
            <p className="text-lg font-bold text-[#2F5E96] break-all">{quoteId}</p>
          </div>
        )}
        
        <Button
          onClick={() => navigate('/')}
          className="w-full bg-[#2F5E96] hover:bg-[#254b7a] text-white h-14 text-lg font-bold rounded-xl"
          data-testid="new-quote-button"
        >
          Create Another Quote
        </Button>
      </div>
    </div>
  );
};

export default ThankYou;